export const LOGIN_URL = 'auth/login';
export const LANGUAGE_URL = 'languages';
export const LANGUAGES_ACTIVE_URL = 'languages/active';
export const LANG_DEFAULT_URL = 'languages/default/';
export const CATEGORIES_PAGINATION_URL = 'categories/paginate';
export const CATEGORIES_URL = 'categories';
export const CATEGORIES_PAGINATE_URL = 'categories/paginate';
export const UNIT_URL = 'units';
export const UNIT_PAGINATE_URL = 'unit/paginate';
export const SHOP_URL = 'shops';
export const SHOP_PAGINATION_URL = 'shops/paginate?perPage=';
export const CURRENCIES_URL = 'currencies';
export const GALLERIES_URL = 'galleries';
export const PRODUCTS_URL = 'products';
export const PRODUCTS_PAGINATION_URL = 'products/paginate';
export const PRODUCTS_SEARCH_URL = 'products/search?search=';
export const BRAND_URL = 'brands';
export const SUBSCRIPTION_URL = 'subscriptions';
export const USER_SEARCH_URL = 'users/search?search=';
export const USER_URL = 'users';
export const USER_PAGINATION_URL = 'users/paginate';
export const ROLE_URL = 'roles';
export const SEARCH_URL = '/search?search=';
export const EXTRA_GROUP_URL = 'extra/groups';
export const EXTRA_VALUE_URL = 'extra/values';
export const ORDER_PAGINATE = 'orders/paginate';
export const ORDER = 'orders';
export const ORDER_DETAILS = 'order/details/paginate';
export const DELIVERY = 'deliveries';
export const COUPON = 'coupons';

// GiftApi COnstants

export const GIFT_API_TOKEN = 'giftauthtoken';
export const GIFT_AUTH_CODE_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/dashboard/quickgift/auth`;
export const GIFT_AUTH_TOKEN_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/dashboard/quickgift/authtoken?authcode=`;
export const GIFT_PRODUCTS_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/dashboard/quickgift/products?token=`;
